









// Ibs
//  export const variables={

//   API_URL:"https://menafn.com/mgmt_react/API/api" 


//  ,ImageStart: "https://menafn.com/updates/pr/"

//             ,basename: '' 
//             ,basename_url: 'https://menafn.com/' 
//             ,domain_name: 'http://menafn.com'
//             ,domain: 'Menafn'

//   }





// Main LocalHost   
// export const variables={


//   API_URL:"http://localhost:6605/api" 


// ,ImageStart: "https://menafn.com/updates/pr/"

//              ,basename: '' 
//             ,basename_url: 'https://menafn.com/' 
//             ,domain_name: 'http://menafn.com'
//             ,domain: 'menafn'         
//   }


// News LocalHost   
// export const variables={


//   API_URL:"http://localhost:6605/api" 


// ,ImageStart: "https://athletixnet.com/updates/pr/"

//              ,basename: '' 
//             ,basename_url: 'https://athletixnet.com/' 
//             ,domain_name: 'http://athletixnet.com'
//             ,domain: 'athletixnet'         
//   }




// //Online   
export const variables = {


  API_URL: "https://athletixnet.com/mgmt_react/API/api"
  , ImageStart: "https://athletixnet.com/updates/pr/"

  , basename: ''
  , basename_url: 'https://athletixnet.com/'
  , domain_name: 'https://athletixnet.com'
  , domain: 'athletixnet'


}




